import { render } from "./DataKey.vue?vue&type=template&id=4852bb9a&scoped=true"
import script from "./DataKey.vue?vue&type=script&lang=ts"
export * from "./DataKey.vue?vue&type=script&lang=ts"

import "./DataKey.vue?vue&type=style&index=0&id=4852bb9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4852bb9a"

export default script